import Container from 'components/container';

import style from './tab.module.scss';

const Tab = ({ className, tabs, color, onChange, disable, active = 0 }) => {
  return (
    <div className={style.scrollDiv}>
      <div className={style.innerScrollDiv}>
        <Container>
          <div className={`${style.wraper} ${className}`}>
            {tabs.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`${style.items} `}
                  style={{
                    borderBottom: active === index ? `1px solid ${color}` : '',
                    color: active === index ? `${color}` : '#696F7A',
                    transition: 'all 1s',
                    marginBottom: '-1px',
                  }}
                  onClick={() => {
                    !disable ? onChange(index) : null;
                  }}
                >
                  <span
                    style={{
                      fontWeight: active === index ? 600 : 500,
                    }}
                  >
                    {item.name}
                  </span>
                </div>
              );
            })}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Tab;
